<template lang="pug">
	.audio-track-info--plugins-bank
		Popup(v-if="pluginsBankVisible", :popupVisible="pluginsBankVisible" :width="580", :title="$auth.hasProAudio() ? $tCaption('Plugin and effects banks') : $tCaption('Effects banks')", 
			:closeOnOutsideClick="false" @hiding="$emit('update:pluginsBankVisible', false)", classes="tracker-dark", ref="popup", :autosize="true")
			PopupBody(slot="body", @content-changed="onContentChanged")
				ListView.full-width(ref="listView", initialView="table", :remoteSorting="true", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", selectionMode="single", @selection="onSelection"
					:getItems="(r) => r.Results", :getData="getTemplateInsertions", :selectedRowKeys="selectedRowKeys", valueExpr="Oid", :columns="columns", :filterRow="true", :showColumnHeaders="false", :searchVisible="false", 
					:pageSize="7", :bottomPagerVisible="false")
					template(slot="left-actions")
						DxButton(v-if="aggregatedTrack || masterTrackConfig", icon="save", :text="$tCaption('Save current')", :hint="$tCaption('Save current settings as plugin and effects bank')" @click="showSaveCurrentBank")
					template(v-slot:name-template="{ data }")
						.flex-row.justify.align-center.hoverable.clickable(@dblclick="onDblClick(data)")
							span {{data.Name || $tCaption('Template')}}
							DxButton(icon="trash", type="danger", stylingMode="text", @click="removePluginsBank(data)")
				template(slot="actions-right")
					slot(name="actions-right")
		Popup(v-if="currentBankSavingPopup.visible", :popupVisible="currentBankSavingPopup.visible" :width="400", :height="220", :title="$tCaption('New plugin and effects bank')", 
			:closeOnOutsideClick="false" @hiding="onHiding", classes="tracker-dark")
			.flex-col.space
				DxTextBox(:value.sync="currentBankSavingPopup.name", valueChangeEvent="keyup", :placeholder="$tCaption('Name')", stylingMode="filled")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="() => saveCurrentAsPluginBank(false)", :disabled="!currentBankSavingPopup.name || isSaving")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="currentBankSavingPopup.visible = false")
</template>

<script>
	import VueTypes from 'vue-types';
	import ListView from 'app-core/ListView.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import PopupBody from 'app-core/PopupBody.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackInfoPanel',
		name: 'audio-track-info--plugins-bank',
		components: { ListView, DxButton, DxTextBox, Popup, PopupBody },
		props: {
			aggregatedTrack: VueTypes.any.def(null),
			masterTrackConfig: VueTypes.any.def(null),
			pluginsBankVisible: VueTypes.any.def(false)
		},
		data() {
			return {
				columns: [{ dataField: 'Name', caption: this.$tCaption('Bank'), cellTemplate: 'name-template' }],
				currentBankSavingPopup: {
					name: null,
					visible: false
				},
				isSaving: false,
				selectedBank: null
			}
		},
		mounted() {
			if (__DEBUG__) {
				window.pluginsBank = this;
			}

			this.$eventsBus.$on('tracker--save-current-plugins-bank', this.onSaveCurrentPluginsBank);
		},
		watch: {
			aggregatedTrack() {
				if (this.$refs.listView) {
					this.$refs.listView.reload();
				}
			},
			masterTrackConfig() {
				if (this.$refs.listView) {
					this.$refs.listView.reload();
				}
			},
		},
		destroyed() {
			this.$eventsBus.$off('tracker--save-current-plugins-bank', this.onSaveCurrentPluginsBank);
		},
		computed: {
			selectedRowKeys() {
				var value = this.aggregatedTrack?.selectedPluginBank;
				return value ? [value] : [];
			}
		},
		methods: {
			onDblClick(data) {
				if (__DEBUG__)
					console.debug('Dbl click', { data });

				this.setSelectedBank(data);
				this.$nextTick(() => this.$emit('apply'));
			},
			onContentChanged(v) {
				if (this.$refs.popup) {
					this.$refs.popup.onContentChanged(v);
				}
			},
			onSaveCurrentPluginsBank() {
				this.showSaveCurrentBank();
			},
			getTemplateInsertions(pageIndex, limit, opts) {
				let filter = opts && opts.filter && opts.filter;

				let tagFilter = ['Tag', '=', this.aggregatedTrack ? '#track' : '#master'];
				let bankFilter = this.aggregatedTrack ? [['Tag', '=', null], 'OR', tagFilter] : tagFilter;

				filter = filter?.length ? [filter, 'AND', bankFilter] : bankFilter;

				let filterCriteria = `${filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(filter))}` || ''}`;
				let sorting = opts.sort && `&sorting=${encodeURIComponent(JSON.stringify(opts.sort))}` || '';
				return this.$Data.getExternalApi('Creative/GetTemplateInsertions', `page=${pageIndex + 1}${filterCriteria}${sorting}`, limit);
			},
			showSaveCurrentBank() {
				this.currentBankSavingPopup.visible = false;
				this.currentBankSavingPopup.name = null;
				setImmediate(() => {
					if (this.__isDestroyed) return;
					this.currentBankSavingPopup.visible = true;
				})
			},
			async saveCurrentAsPluginBank() {
				const templateName = this.currentBankSavingPopup.name;
				this.isSaving = true;
				try {
					await this.$Data.postExternalApi('Creative/CreateUpdateTemplateInsertion', {
						Oid: null,
						Name: templateName,
						JsonConfig: this.aggregatedTrack || this.masterTrackConfig,
						Tag: this.aggregatedTrack ? '#track' : '#master'
					}).then((r) => {
						if (r?.Success !== false) {
							this.$notifySuccess(this.$tCaption('Bank saved successfully'));
						}
					});
					this.currentBankSavingPopup.visible = false;
					if (this.$refs.listView && this.pluginsBankVisible) {
						this.$refs.listView.reload();
					}
				} finally {
					this.isSaving = false;
				}
			},
			onHiding() {
				this.currentBankSavingPopup.visible = false;
			},
			onSelection(v) {
				this.setSelectedBank(v && v[0]);
			},
			setSelectedBank(v) {
				this.selectedBank = v;
				this.$emit('select', this.selectedBank);
			},
			removePluginsBank(pluginsBank) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete the bank?'),
					handler: async () => {
						await this.$Data.getExternalApi('Creative/DeleteInsertion', `insertionId=${pluginsBank?.Oid}`)
						this.$notifySuccess(this.$tCaption('Bank deleted'), 600);
						this.$refs.listView.reload();
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	.audio-track-info--plugins-bank {
		@import "main/themes/generated/variables.base.scss";
	}
</style>
